import {showNotification} from "@/helpers/toastr-helper";
import {getGeometryByLayerName} from "@/helpers/ol-layer-helper";
import {getDefaultName} from "@/helpers/geo-json-helper";

export function checkValidFields(currentStepIndex) {

    const wizardItem = window.wizard.Items[currentStepIndex]

    const wizardItemChild = wizardItem.Items.find(item => [24, 25, 26, 27, 240, 250, 260].includes(item.AttributeTypeID))

    let allValid = true
    const wizardBody = document.querySelector('wizard-body[data-key="' + currentStepIndex + '"]')

    wizardBody.querySelectorAll('form-text').forEach(formText => {
        if(formText.dataset.isRequired) {
            const input = formText.querySelector('input')

            // Check if it has value and if it is visible
            if(!input.value && input.offsetLeft > 0) {
                allValid = false
                input.classList.add('is-invalid')
            } else {
                input.classList.remove('is-invalid')
            }
        }
    })

    wizardBody.querySelectorAll('form-domain-list-single, form-checkbox').forEach(formDomainListItem => {

        if(formDomainListItem.dataset.isRequired) {
            let hasActive = false
            formDomainListItem.querySelectorAll('.list-group-item').forEach(listGroupItem => {
                if (listGroupItem.classList.contains('active')) {
                    hasActive = true
                }
            })

            if (!hasActive) {
                const element = formDomainListItem.querySelector('.invalid-feedback')
                if (element) {
                    element.classList.add('d-block')
                }
                allValid = false
            } else {
                formDomainListItem.querySelector('.invalid-feedback').classList.remove('d-block')
            }
        }
    })

    if(!allValid) {
        showNotification('Nog niet alle verplichten velden zijn ingevuld', '', 'warning')
        return false
    }

    if(wizardItemChild) {
        if(!getGeometryByLayerName(getDefaultName())) {
            showNotification('U moet eerst een locatie kiezen om verder te gaan', '', 'warning')
            return false
        }
    }
    return true
}
